module.exports = __webpack_public_path__ + "static/media/Insight.a33e772d.svg";